import { gql } from '@grandvisionhq/graphql';
import { discount } from './discount.js';
import { legacyProduct } from './legacy-product.js';
import { lineItemPrice } from './line-item-price.js';

const lineItemBundle = gql`
  fragment LineItemBundleFragment on LineItemBundle {
    id
    sku
    lineItemType
    bundleLineItemsType
    bundleLineItems {
      sku
      type
      isMainBundleLineItem
      quantity
      discounts {
        ...DiscountFragment
      }
      price {
        ...LineItemPriceFragment
      }
      legacyProduct {
        ...LegacyProductFragment
      }
    }
  }
  ${legacyProduct}
  ${lineItemPrice}
  ${discount}
`;

export { lineItemBundle };
//# sourceMappingURL=line-item-bundle.js.map
